import { DEFAULT_LOCALE } from "@/utils/localeUtils.js";

export function buildEventPublicUrl(slug, defaultLocale = DEFAULT_LOCALE) {
  const base = (import.meta.env.VITE_CONCERTS_URL || window.location.origin).replace(/\/$/, "");
  return `${base}/${slug}?lang=${defaultLocale}`;
}
